/* Pause/Play toggle videoille korteissa ja zoom-näkymässä.
   - Klikkaus mihin tahansa videon päällä (tai kuvakkeeseen) -> toggle
   - Ei tuplatogglea: suojataan 250ms ikkunalla
   - Estetään zoom vain videoilla; kuvilla zoom toimii
   - Ikonin aria-label päivittyy videon tilan mukaan
*/
(() => {
  if (window.__pvBoundOnce) return;
  window.__pvBoundOnce = true;

  const PLAY_SVG  = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  const PAUSE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';
  const TOGGLE_GUARD_MS = 250;

  const qsa = (r, s) => Array.from((r || document).querySelectorAll(s));
  const cardOf = (el) => el?.closest?.('.product-media, .zoom-media, .media') || null;
  const isVideoCard = (card) => !!(card && card.querySelector('figure.media--video video, .media--video video, video'));
  const getVideo = (card) => card?.querySelector?.('video') || null;

  function ensureOverlayButton(card) {
    // Käytä olemassa olevaa zoom-linkkiä napin ulkoasuun
    let btn = card.querySelector('.product-media-zoom-link');
    if (btn) {
      // Poista zoom vain videoilta
      if (!btn.hasAttribute('data-video-zoom-disabled')) {
        if (btn.hasAttribute('href')) {
          btn.setAttribute('data-original-href', btn.getAttribute('href'));
          btn.removeAttribute('href'); // estä :target/navigointi videoilla
        }
        btn.setAttribute('data-video-zoom-disabled', 'true');
        btn.setAttribute('role', 'button');
        btn.tabIndex = 0;
        btn.classList.add('video-toggle'); // käyttää antamaasi CSS:ää
      }
      return btn;
    }
    // Zoom-näkymässä ei välttämättä ole linkkiä -> luodaan nappi
    btn = card.querySelector('.video-toggle');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'video-toggle';
      btn.setAttribute('role', 'button');
      btn.tabIndex = 0;
      card.appendChild(btn);
    }
    return btn;
  }

  function setUI(btn, playing) {
    if (!btn) return;
    btn.setAttribute('aria-label', playing ? 'Pysäytä video' : 'Toista video');
    btn.innerHTML = playing ? PAUSE_SVG : PLAY_SVG;
    btn.dataset.videoState = playing ? 'playing' : 'paused';
  }

  function toggleOnce(video) {
    if (!video) return;
    const now = performance.now();
    const last = parseFloat(video.dataset._pvLastToggle || '0');
    if (now - last < TOGGLE_GUARD_MS) return; // estä tuplat
    video.dataset._pvLastToggle = String(now);
    try { video.paused ? video.play() : video.pause(); } catch (e) {}
  }

  function bindCard(card) {
    if (!isVideoCard(card) || card.__pvBound) return;
    card.__pvBound = true;

    const video = getVideo(card);
    const btn = ensureOverlayButton(card);

    // Alku-UI
    setUI(btn, !video.paused && !video.ended);

    // Synkkaa ikonit aina kun tila vaihtuu
    ['play','pause','ended'].forEach(ev => {
      video.addEventListener(ev, () => setUI(btn, !video.paused && !video.ended));
    });
  }

  function init(root = document) {
    qsa(root, '.product-media, .zoom-media, .media').forEach((card) => {
      if (isVideoCard(card)) bindCard(card);
    });
  }

  // YKSI keskitetty click-käsittelijä (capture): overlay-linkki, oma ikoni TAI itse <video>
  document.addEventListener('click', (e) => {
    // Jos kohde on video tai sen päällä oleva nappi/linkki
    const videoEl = e.target.closest?.('video');
    const toggleBtn = e.target.closest?.('.video-toggle');
    const zoomLink  = e.target.closest?.('.product-media-zoom-link');

    // 1) Suora klikkaus videolle -> toggle
    if (videoEl) {
      const card = cardOf(videoEl);
      if (!isVideoCard(card)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      toggleOnce(videoEl);
      return;
    }

    // 2) Klikkaus play/pause-kuvakkeeseen -> toggle
    if (toggleBtn) {
      const card = cardOf(toggleBtn);
      const video = getVideo(card || document);
      if (!video) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      toggleOnce(video);
      return;
    }

    // 3) Klikkaus zoom-linkkiin videokortilla -> estä zoom ja toggle
    if (zoomLink) {
      const card = cardOf(zoomLink);
      if (!isVideoCard(card)) return; // kuvilla zoom normaalisti
      const video = getVideo(card);
      if (!video) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      toggleOnce(video);
    }
  }, true); // capture, jotta zoomin omat kuuntelijat eivät ehdi väliin

  // Näppäimistö (Enter/Space) ikonille/overlaylle
  document.addEventListener('keydown', (e) => {
    const target = e.target.closest?.('.video-toggle, .product-media-zoom-link[data-video-zoom-disabled]');
    if (!target) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const card = cardOf(target);
    const video = getVideo(card || document);
    if (!video) return;
    e.preventDefault();
    toggleOnce(video);
  }, true);

  // Alustus + dynaamiset lisäykset
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (!(n instanceof HTMLElement)) continue;
        if (n.matches?.('.product-media, .zoom-media, .media') || n.querySelector?.('.product-media, .zoom-media, .media')) {
          init(n);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
